<template>
	<div>
		<v-textarea
			:rows="3"
			auto-grow
			:class="dense ? 'grv-input-dense' : 'grv-input'"
			:rules="rules"
			:name="param.name"
			@update:error="errored = $event"
			:value="value"
			clearable
			@input="$emit('update:value', $event)"
			:readonly="readonly">

			<template v-slot:label>
				<Label :param="param"></Label>
			</template>
		</v-textarea>

		<Hint :param="param" :errored="errored"></Hint>
	</div>
</template>

<script>
import Label from '@/components/fields/label.vue'
import Hint from '@/components/fields/hint.vue'
export default {
	props: [
		'param',
		'value',
		'readonly',
		'dense'
	],
	components: {
		Label,
		Hint
	},
	data () {
		return {
			rules: [],
			errored: false
		}
	},
	methods: {
		requiredCheck (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			return true
		}
	},
	mounted () {
		if (!this.param) return
		if (this.param.required || this.param.required === undefined) {
			this.rules.push(this.requiredCheck)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/fields/text.vue